<template>
    <section id="section">
        <div class="tab-lists-container">
            <div class="tab-title-container">
                <div class="tab-m-title-container">
                    <i class="icon-dancer"></i>
                    <span class="tab-m-title">Dancer</span>
                </div>
                <ul class="tab-lists-title-box">
                    <li class="tab-lists-title">
                        <router-link :class="`tab-lists-link${sort ? '' : ' router-link-active'}`" to="/dancers" exact>全部</router-link>
                    </li>
                    <li class="tab-lists-title" v-for="v in sorts" :key="v.id">
                        <router-link :class="`tab-lists-link${sort === v.id ? ' router-link-active' : ''}`" :to="`/dancers?sort=${v.id}`" exact>{{v.name}}</router-link>
                    </li>
                </ul>
            </div>
            <div class="tab-border-container">
                <div class="tab-s-border"></div>
                <div class="tab-m-border"></div>
            </div>
        </div>

        <!--<router-view :dancers="dancers" :counts="counts" :page="page"></router-view>-->

        <ul class="video-lists-box">
            <li class="video-lists" v-for="v in dancers" :key="v.id">
                <div class="dancer-lists-link">
                    <router-link class="dancer-thumb-link pr" :to="`/dancers/${v.id}`">
                        <img class="dancer-thumb" v-lazy="{src: v.thumb, error: 'https://img.vhiphop.com/web/loading-1.gif', loading: 'https://img.vhiphop.com/web/loading-1.gif'}" :alt="v.name">
                    </router-link>

                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <router-link :to="`/dancers/${v.id}`" class="dancer-title-link">
                                <h3 class="video-title ellipsis">{{v.name}}</h3>
                            </router-link>

                            <span class="dancer-tips ellipsis">{{v.sorts}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="dancer-counts" :title="`人气值: ${v.views}`">
                                <i class="icon-hot"></i> {{$view(v.views)}}
                            </span>
                            <span class="dancer-counts" title="关注舞者">
                                <i class="icon-liked"></i> {{v.fans}}
                            </span>
                        </p>
                    </div>
                </div>
            </li>
        </ul>

        <el-pagination v-if="dancers.length && total > 40" :current-page="page"  @current-change="currentChange" :page-size="40" :total="total" background layout="total, prev, pager, next"></el-pagination>

    </section>
</template>

<script>
    export default {
        data: () => ({
            sorts: [],
            dancers: [],
            total: 0,
        }),
        computed: {
            sort() {
                return +this.$route.query.sort || 0;
            },
            page() {
                return +this.$route.query.page || 1;
            }
        },
        methods: {
            currentChange(page) {// 页码改变
                this.$router.push(`/dancers?sort=${this.sort}&page=${page}`);
            },
        },
        beforeMount() {
            const {api, sort, page} = this;

            Promise.all([
                api.get('dancers/sorts').then(e => this.sorts = e),
                api.get('dancers', {sort, page}).then(e => this.dancers = e),
                api.get('dancers/count', {sort}).then(e => this.total = e)
            ]).catch(this.err);
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            let {sort, page} = to.query, {api} = this;
            sort = +sort || 0;
            page = +page || 1;
            Promise.all([
                api.get('dancers', {sort, page}).then(e => this.dancers = e),
                api.get('dancers/count', {sort}).then(e => this.total = e)
            ]).catch(this.err);
            next();
        },
    }
</script>

<style scoped>
    @import "../../../static/css/common/tab.css";
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/dancer/lists.css";
</style>



// WEBPACK FOOTER //
// src/views/dancer/List.vue